(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"]) return;
  try {
    
  class BannerCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.slides = this.querySelectorAll('.banner-carousel__slide');
      this.totalSlides = this.slides.length;
      this.autoplayDelay = 8000;
      this.autoplayTimer = null;
      
      this.init();
    }

    init() {
      // Only setup navigation and autoplay if there's more than one slide
      if (this.totalSlides > 1) {
        // Setup navigation buttons
        const prevButton = this.querySelector('[data-direction="prev"]');
        const nextButton = this.querySelector('[data-direction="next"]');
        
        if (prevButton) {
          prevButton.addEventListener('click', () => this.navigate('prev'));
        }
        
        if (nextButton) {
          nextButton.addEventListener('click', () => this.navigate('next'));
        }

        // Start autoplay
        this.startAutoplay();

        // Pause autoplay on hover
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      } else {
        // Hide navigation buttons if only one slide
        const prevButton = this.querySelector('[data-direction="prev"]');
        const nextButton = this.querySelector('[data-direction="next"]');
        
        if (prevButton) {
          prevButton.style.display = 'none';
        }
        
        if (nextButton) {
          nextButton.style.display = 'none';
        }
      }
    }

    navigate(direction) {
      const previousSlide = this.currentSlide;
      
      // Calculate next slide
      if (direction === 'next') {
        this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
      } else {
        this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      }
      
      // Add active class to new slide first (cross-fade)
      this.slides[this.currentSlide].classList.add('banner-carousel__slide--active');
      this.slides[this.currentSlide].style.zIndex = '2';
      
      // Wait for transition to complete before removing previous slide
      setTimeout(() => {
        this.slides[previousSlide].classList.remove('banner-carousel__slide--active');
        this.slides[previousSlide].style.zIndex = '1';
      }, 1200); // Match transition duration
      
      // Restart autoplay only for manual navigation
      if (direction !== 'auto') {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay(); // Clear any existing timer
      this.autoplayTimer = setInterval(() => {
        this.navigate('auto');
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  customElements.define('banner-carousel', BannerCarousel);

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('[data-banner-carousel]');
    if (carousel && !customElements.get('banner-carousel')) {
      // Fallback if custom elements not supported
      const bannerCarousel = new BannerCarousel();
      Object.setPrototypeOf(carousel, BannerCarousel.prototype);
      BannerCarousel.call(carousel);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
